import { useDetailsResource } from 'framework/ViewTypes/hooks';
import usePositionSlotsService from '../../usePositionSlotsService';

const usePositionSlotDetails = (id?: string) => {
  const { getPositionSlot } = usePositionSlotsService();
  const { data: positionSlot, ...state } = useDetailsResource(id, getPositionSlot);
  return { positionSlot, ...state };
};

export default usePositionSlotDetails;
